var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.227,
    height: 45.237,
    viewBox: "0 0 84.227 45.237",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(-43.75 -28.251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37230",
    "data-name": "Path 37230",
    d: "M60.551,455.107V419.033a4.184,4.184,0,0,1,1.314-3.044l.032-.03a4.155,4.155,0,0,1,2.854-1.135h76.241c1.076-.018,2.2.018,3.28,0,.019,1.291-.015,2.527,0,3.819V455.1a4.561,4.561,0,0,1-1.472,3.448,4.058,4.058,0,0,1-2.359,1H65.006a4.51,4.51,0,0,1-3.168-1.2l-.074-.074A4.483,4.483,0,0,1,60.551,455.107Z",
    transform: "translate(-16.551 -386.317)",
    fill: "#f9e107",
    stroke: "#050e27",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26718",
    "data-name": "Group 26718",
    transform: "translate(51.743 59.652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37231",
    "data-name": "Path 37231",
    d: "M133.52,689.818a2.073,2.073,0,0,0,.533-.557,2.3,2.3,0,0,0,.307-1.217,2.258,2.258,0,0,0-.785-1.8,3.46,3.46,0,0,0-2.171-.6h-3.179a1.11,1.11,0,0,0-1.114,1.114v7.977h4.167A3.823,3.823,0,0,0,133.76,694a2.683,2.683,0,0,0,.878-2.123,2.4,2.4,0,0,0-.365-1.379A2.361,2.361,0,0,0,133.52,689.818Zm-4.282-2.25h1.813a1.439,1.439,0,0,1,.861.161.777.777,0,0,1,0,1.084,1.434,1.434,0,0,1-.836.186h-1.838Zm2.877,4.953a1.627,1.627,0,0,1-.963.238h-1.914V690.9h1.889a1.638,1.638,0,0,1,.983.208.857.857,0,0,1,.275.722A.787.787,0,0,1,132.116,692.52Z",
    transform: "translate(-127.112 -685.618)",
    fill: "#050e27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37232",
    "data-name": "Path 37232",
    d: "M220.795,693.913a1.772,1.772,0,0,1-.022-.294v-.338l-.051-1.036a3.144,3.144,0,0,0-.3-1.376,1.394,1.394,0,0,0-.5-.5,1.771,1.771,0,0,0,.641-.62,2.937,2.937,0,0,0-.388-3.447,3.288,3.288,0,0,0-2.231-.657h-3.305a1.11,1.11,0,0,0-1.114,1.114v7.977h2.2v-3.381h1.687a1.255,1.255,0,0,1,.829.208,1.9,1.9,0,0,1,.252.954l.025.928a5.272,5.272,0,0,0,.051.573,1.671,1.671,0,0,0,.172.6l.057.113h2.889l-.695-.385A.617.617,0,0,1,220.795,693.913Zm-2.3-4.715a1.356,1.356,0,0,1-.877.229h-1.889v-1.885h1.99a1.052,1.052,0,0,1,.776.254,1.09,1.09,0,0,1,0,1.4Z",
    transform: "translate(-203.472 -685.618)",
    fill: "#050e27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37233",
    "data-name": "Path 37233",
    d: "M303.657,685.643a1.055,1.055,0,0,0-1.051.717l-2.974,8.373h2.335l.555-1.791h3.08l.58,1.791h2.335l-3.3-9.09Zm-.524,5.425.927-2.821.927,2.821Z",
    transform: "translate(-279.563 -685.618)",
    fill: "#050e27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37234",
    "data-name": "Path 37234",
    d: "M405.523,685.643H402.7l-3.088,3.249v-3.249H398.52a1.11,1.11,0,0,0-1.114,1.114v7.977h2.2v-3.258c0-.142.04-.319.351-.423.234-.077.518.1.84.517l2.257,3.164h2.68l-3.92-5.357Z",
    transform: "translate(-365.963 -685.618)",
    fill: "#050e27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37235",
    "data-name": "Path 37235",
    d: "M489.568,685.968a1.078,1.078,0,0,0-.325.789v7.977h6.719v-2.026H491.42V690.9h2.267a1.11,1.11,0,0,0,1.114-1.114V689H491.42v-1.456h4.541v-1.9h-5.6A1.078,1.078,0,0,0,489.568,685.968Z",
    transform: "translate(-447.117 -685.618)",
    fill: "#050e27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37236",
    "data-name": "Path 37236",
    d: "M573.452,691.056a2.05,2.05,0,0,1-.348,1.347,1.5,1.5,0,0,1-1.137.39,1.459,1.459,0,0,1-1.126-.376,2.214,2.214,0,0,1-.334-1.361v-5.63h-1.114a1.042,1.042,0,0,0-.8.357,1.165,1.165,0,0,0-.319.807v4.668a3.36,3.36,0,0,0,.969,2.593,4.588,4.588,0,0,0,5.431.006,3.364,3.364,0,0,0,.975-2.6v-5.832h-2.2Z",
    transform: "translate(-516.96 -685.426)",
    fill: "#050e27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37237",
    "data-name": "Path 37237",
    d: "M659.456,686.412a2.958,2.958,0,0,0-2.217-.769h-2.952a1.11,1.11,0,0,0-1.114,1.114v7.977h2.2v-3.1h1.99a2.816,2.816,0,0,0,2.121-.774,3.188,3.188,0,0,0,.734-2.206A3.049,3.049,0,0,0,659.456,686.412Zm-1.681,3a1.216,1.216,0,0,1-.864.243h-1.536v-2.087h1.636a.882.882,0,0,1,1.031,1.031A1.021,1.021,0,0,1,657.775,689.412Z",
    transform: "translate(-591.978 -685.618)",
    fill: "#050e27"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_37238",
    "data-name": "Path 37238",
    d: "M320.806,502.037a.631.631,0,1,1-.583.391,5.5,5.5,0,0,0,1.03,6.018.614.614,0,1,1,.017.018,5.49,5.49,0,0,0,3.985,1.708h0a5.481,5.481,0,0,0,3.165-1,.655.655,0,1,1,.015-.011,5.5,5.5,0,0,0,2.327-4.5h0a5.507,5.507,0,0,0-9.4-3.894l0,0-.006.006,0,0a5.517,5.517,0,0,0-1.127,1.633A.63.63,0,0,1,320.806,502.037Zm.555,6.523,0,0,.008.008Zm7.789,0,0,0,.008-.008Zm0-.9,0,0,0,0Zm.747-5.13a.629.629,0,1,1-.629.629A.629.629,0,0,1,329.893,502.532Zm-4.4-3.368a.63.63,0,1,1-.63.63A.63.63,0,0,1,325.493,499.165Zm-3.238,2.5a4.243,4.243,0,0,1,7.244,3h0a4.23,4.23,0,0,1-1.243,3h0a4.243,4.243,0,0,1-6-6Zm-.892,0,0,0,0,0Z",
    transform: "translate(-245.596 -461.174)",
    fill: "#050e27"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1712",
    "data-name": "Ellipse 1712",
    cx: 2.815,
    cy: 2.815,
    r: 2.815,
    transform: "translate(76.622 40.918) rotate(-4.731)",
    fill: "#050e27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37239",
    "data-name": "Path 37239",
    d: "M275.279,470.089a11.378,11.378,0,1,0-4.664-15.4A11.377,11.377,0,0,0,275.279,470.089Zm.057-14.8-.123.568-5.5,2,.123-.568Zm8.279-1.449-2.921-5.075.581.023,2.284,3.969.645,1.089h-.364Zm3.7,8.989-.077-.576,4.494-3.753.077.576Zm-9.865,3.194a6.772,6.772,0,1,1,9.165-2.776A6.772,6.772,0,0,1,277.452,466.027Zm7.745,4.224-4.905-3.041.518-.258,4.905,3.041Zm-11.666-1.6.36-5.845.472.339-.36,5.845Z",
    transform: "translate(-200.988 -416.565)",
    fill: "#050e27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37240",
    "data-name": "Path 37240",
    d: "M436.333,450.028a11.363,11.363,0,0,0-10.466-.141c-.113.056-.225.115-.336.176-.087.048-.174.1-.261.148a14.471,14.471,0,0,1,3.364,3.484q.091-.033.181-.063c.052-.019.106-.035.158-.051s.107-.033.161-.048.088-.026.133-.036c.172-.045.346-.084.522-.115q.082-.016.167-.028.147-.023.3-.038l.1-.01.12-.01.164-.009c.057,0,.115-.006.173-.007l.172,0a6.771,6.771,0,0,1,3.807,12.373l-.013.008q-.086.058-.171.112c-.052.035-.107.068-.161.1-.03.02-.062.037-.093.055s-.078.045-.118.066-.077.043-.115.062a6.763,6.763,0,0,1-5.5.362,11.961,11.961,0,0,1-3.36,3.468c.021.014.043.026.065.038.157.091.318.178.479.261l.01.006c.162.083.325.16.491.236q.5.227,1.031.406l.006,0q.263.089.53.165a11.136,11.136,0,0,0,1.1.254c.093.017.187.033.28.046s.19.028.284.04c.19.024.382.044.573.058.1.008.193.014.29.019s.214.009.322.012c.086,0,.174,0,.262,0a11.374,11.374,0,0,0,3.649-.6c.141-.048.279-.1.418-.15l.206-.081c.114-.046.228-.094.34-.144l.126-.057c.115-.052.229-.107.341-.163.065-.033.129-.065.192-.1l.149-.079.16-.09.154-.087a.125.125,0,0,0,.024-.015l.15-.09a11.379,11.379,0,0,0-.561-19.744Zm-1.828,3.826h-.347l-.225-.009-2.921-5.075.58.023,2.285,3.97.644,1.089Zm1.011,16.4-4.906-3.041.518-.257L436.034,470Zm2.119-7.418-.077-.576,4.494-3.754.078.576Z",
    transform: "translate(-338.834 -416.568)",
    fill: "#050e27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37241",
    "data-name": "Path 37241",
    d: "M394.316,585.146l-.015.011Z",
    transform: "translate(-311.477 -537.159)",
    fill: "#050e27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37242",
    "data-name": "Path 37242",
    d: "M323.831,527.085l.011-.025Z",
    transform: "translate(-249.204 -485.83)",
    fill: "#050e27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37243",
    "data-name": "Path 37243",
    d: "M332.7,579.022l-.017-.018Z",
    transform: "translate(-257.028 -531.731)",
    fill: "#050e27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37244",
    "data-name": "Path 37244",
    d: "M463.448,509.277a.632.632,0,0,1-.359-1.151,4.253,4.253,0,0,1-3.688.6,11.578,11.578,0,0,1-.5,1.169,5.5,5.5,0,0,0,4.894-.724A.629.629,0,0,1,463.448,509.277Zm2.259-6.756a5.514,5.514,0,0,0-6.8-3.088,11.565,11.565,0,0,1,.5,1.168,4.245,4.245,0,0,1,3.691,7.52.631.631,0,0,1,.718,1.039,5.513,5.513,0,0,0,1.894-6.639Zm-4.837-2.1a.63.63,0,1,1,.63-.63A.63.63,0,0,1,460.87,500.424Zm4.4,3.367a.629.629,0,1,1,.629-.63A.629.629,0,0,1,465.27,503.791Z",
    transform: "translate(-368.563 -461.174)",
    fill: "#050e27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37245",
    "data-name": "Path 37245",
    d: "M470.319,525.116a2.818,2.818,0,0,1-3.64,2.693,12.013,12.013,0,0,0,0-5.387,2.818,2.818,0,0,1,3.636,2.694Z",
    transform: "translate(-375.436 -481.625)",
    fill: "#050e27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37246",
    "data-name": "Path 37246",
    d: "M500.992,585.146l-.015.011Z",
    transform: "translate(-405.744 -537.159)",
    fill: "#050e27"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.9cdd3e9b153f8ed02be68c756adc5fd3.svg";
export { ForwardRef as ReactComponent };